import React from 'react';

import { Link } from '~/lib/react-router-dom';

import { Breadcrumbs, Link as MuiLink, Stack, Typography } from '@mui/material';

import { pluralizeToString } from '~/utils/stringUtils';

import SampleDataChip from './SampleDataChip';
import { accountPath } from './accountRelatedModel';
import { useAccountOfferId } from './useAccountOfferId';

interface Props {
  accountId: string;
  count?: number;
  isSampleData?: boolean;
  sortedBy: string;
  title: string;
}

export default function AccountListPageHeader({ accountId, count, isSampleData, sortedBy, title }: Props) {
  const offerId = useAccountOfferId();

  return (
    <>
      <Breadcrumbs sx={{ mb: 2 }}>
        <MuiLink component={Link} to={accountPath(accountId, offerId)} underline="hover">
          Related
        </MuiLink>
        <Typography color="text.primary">{title}</Typography>
      </Breadcrumbs>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <Typography variant="h4">{title}</Typography>
        {isSampleData && <SampleDataChip />}
      </Stack>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {count === undefined ? `Sorted by ${sortedBy}` : `${pluralizeToString('item', count)} · Sorted by ${sortedBy}`}
      </Typography>
    </>
  );
}
